import * as LabelPrimitive from '@radix-ui/react-label';
import type { ComponentProps, ReactElement } from 'react';
import { cn } from './utils';

/**
 * Die Beschriftung aus shadcn/ui — der einzige Baustein hier, der Radix
 * mitbringt.
 *
 * **Was Radix beisteuert und `<label htmlFor>` nicht.** Ein doppelter Klick auf
 * eine gewöhnliche Beschriftung markiert ihren Text; Radix unterdrückt das.
 * Klingt nach nichts, ist aber in einer Maske mit dreissig Feldern der
 * Unterschied zwischen «zweimal geklickt und im Feld gelandet» und «zweimal
 * geklickt und die blaue Markierung liegt über der halben Maske».
 *
 * Die Verknüpfung selbst läuft weiter über `for`/`id` und nicht über
 * Verschachtelung — die Begründung, samt der Falle mit «Libanon», steht bei
 * `Field` in `ui/elements.tsx`.
 *
 * Übersetzt: `group-data-[disabled=true]:…` und `peer-disabled:…` aus der
 * Vorlage sind entfernt. Sie greifen nur in einem `FormField`-Gerüst, das es
 * hier nicht gibt, und `peer` müsste am Feld stehen — das steht bei uns UNTER
 * der Beschriftung und nicht davor.
 */
function Label({
  className,
  ...props
}: ComponentProps<typeof LabelPrimitive.Root>): ReactElement {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'flex select-none items-center gap-2 text-sm font-medium leading-none text-foreground',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
